import style from "./appModePage.module.scss";
import useAuth, { TYPE_USER } from "../../hooks/useAuth";
import AccountHeader from "../../components/AppAccount/AccountHeader";
import AccountForLoggedInUser from "../../components/AppAccount/AccountForLoggedInUser";
import UnauthenticatedUser from "../../components/AppAccount/UnauthenticatedUser";
import AccountPage from "../account/AccountPage";
import useAppModernisation from "../../hooks/useAppModernisation";
import { getProfileName } from "../../utils/authUtils";

const AccountLandingPage = () => {
  const { authDetails, isLogged, email, userProfile } = useAuth();
  const { isMobileView } = useAppModernisation();
  const contactProfileName = getProfileName(authDetails, userProfile);

  if (isMobileView) {
    return (
      <div className={style.accountContainer}>
        <AccountHeader headername="My Account" />
        {isLogged ? (
          <AccountForLoggedInUser
            profileName={contactProfileName}
            email={email}
            isEmailVisible={authDetails?.type === TYPE_USER}
          />
        ) : (
          <UnauthenticatedUser />
        )}
      </div>
    );
  } else {
    return (
      <AccountPage
        profileName={contactProfileName}
        email={email}
        isEmailVisible={authDetails?.type === TYPE_USER}
      ></AccountPage>
    );
  }
};

export default AccountLandingPage;
